import React, { useRef } from "react";
import { useRemoteComponents } from "./internal/use-remote-components.js";
export function createAppLayoutPartLoader({ partName, Fallback, }) {
    const AppLayoutPartLoader = ({ Skeleton, ...props }) => {
        const ref = useRef(null);
        const components = useRemoteComponents(ref, { [partName]: Fallback });
        const Component = components[partName];
        if (Component) {
            return React.createElement(Component, { ...props });
        }
        if (Skeleton) {
            return React.createElement(Skeleton, { ref: ref, ...props });
        }
        return React.createElement("div", { ref: ref });
    };
    return AppLayoutPartLoader;
}
